import React from "react";
import { NavLinks, NavLink } from "./styles";
import { useTranslation } from "react-i18next";

const DefaultNavLinks = ({ activeSection, closeMobileMenu }) => {
	const { t } = useTranslation();

	const handleScroll = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) {
			section.scrollIntoView({ behavior: "smooth" });
			if (closeMobileMenu) closeMobileMenu();
		}
	};

	const links = [
		{ id: "home", label: t("header.heroNavLink") },
		{ id: "services", label: t("header.featuresNavLink") },
		{ id: "practice", label: t("header.pricingNavLink") },
		{ id: "about", label: t("header.testimonialsNavLink") },
		{ id: "expertise", label: t("header.expertiseNavLink") },
		{ id: "contact", label: t("header.footerNavLink") },
	];

	return (
		<NavLinks>
			{links.map((link) => (
				<NavLink
					key={link.id}
					onClick={() => handleScroll(link.id)}
					isActive={activeSection === link.id}
				>
					{link.label}
				</NavLink>
			))}
		</NavLinks>
	);
};

export default DefaultNavLinks;
